const DEBOUNCE_TIMEOUT = 1000;
const RESULT_TEMPLATE  = `<li>{result}</li>`;

const {_, $} = Voonto;

class PredictiveSearch {
  constructor(container$, serviceUrl) {
    this._input$   = container$.find('[data-voc-krammer-predictive-input]');
    this._results$ = container$.find('[data-voc-krammer-predictive-results]');
    this.url       = serviceUrl;

    this._input$.on('keyup', _.debounce(_search, DEBOUNCE_TIMEOUT).bind(this));
  }
}

export default PredictiveSearch;

/* Private */

function _search() {
  var value;

  value = this._input$.val().toLowerCase();
  this._results$.empty();

  if (value !== '') {
    $.ajax({url: this.url}).then((search) => {
      for (let i in search) {
        let result = search[i].name.toLowerCase();
        if (result.indexOf(value) !== -1) {
          this._results$.append(RESULT_TEMPLATE.replace(/{result}/g, result));
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/predictive.js